export class OperationType {
    static BUY_TYPE = 'buy';
    static SELL_TYPE = 'sell';
}